import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  slash: {
    margin: 0,
    color: '#242424',
    padding: '3px 8px',
    fontSize: '14px',
    fontWeight: 700,
  },

  breadcrumbContent: {
    display: 'flex',
    alignItems: 'center',
    minHeight: 30,
  },

  itemBox: {
    '&:hover': {
      cursor: 'pointer',
    },

    '& span': {
      margin: '0 8px',
      color: '#4A4A4A',
      fontSize: '14px',
      transition: 'color 0.3s',

      '&.hovered': {
        color: '#fff !important',
      },

      '&.active': {},
    },
  },

  itemCounter: {
    padding: '0 12px',
    color: '#747474',
    border: '1px solid #242424',
    borderRadius: '100px',
    marginRight: '8px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    transition: 'color 0.3s',
    fontSize: '12px',
    fontWeight: 500,

    '&.hovered': {
      color: '#fff',
    },
  },

  breadcrumbsPopover: {
    '& .MuiPaper-root.MuiPopover-paper': {
      marginTop: '10px',
    },
  },

  dropdownBox: {
    backgroundColor: theme.palette.bg.primary.default,
    border: '1px solid #242424',
    borderRadius: '8px',
  },

  dropdownItem: {
    width: '285px',
    padding: '24px',

    '&:not(:last-child)': {
      borderRight: `1px solid ${theme.palette.brand.gray[800] ?? '#242424'}`,
    },
  },

  itemName: {
    fontSize: '14px',
    lineHeight: '24px',
    fontWeight: 300,
    color: theme.palette.brand.gray[400],
  },

  itemContent: {
    cursor: 'pointer',
    transition: 'color 0.3s, transform 0.9s, opacity 0.9s',

    '&:hover span': {
      color: '#fff',
    },
  },

  emptyItem: {
    color: theme.palette.brand.gray[400],
  },

  allLink: {
    fontWeight: 500,
    fontSize: '14px',
    color: '#9667ED',
    cursor: 'pointer',

    '& svg': {
      marginLeft: '8px',
    },
  },
}));
